










































import { Component, Vue, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'

// Mixins
import MatchMixin from '@/mixins/match'

// Types
import { Match } from '@/types/match'

// Views
import AdjustmentButtons from './AdjustmentButtons.vue'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - Not developed with TS
import VueEllipseProgress from 'vue-ellipse-progress'

// VueEllipseProgress library must be injected like this.. It cannot be parsed as component somehow...
Vue.use(VueEllipseProgress)

@Component({
  components: {
    AdjustmentButtons,
  },

  computed: {
    ...mapState('match', ['match', 'controlsLocked']), // map state-properties from 'match'-module
  },
})
export default class GameClockMain extends MatchMixin {
  /**
   * On match changed
   */
  @Watch('match', { immediate: true })
  onMatchChanged(val: Match | null): void {
    if (val === null) {
      this.stopRealtimeInterval()
      return
    }

    if (val.gcState === 'STARTED') {
      this.startRealtimeInterval()
      return
    }

    this.stopRealtimeInterval()
  }

  @Watch('match.gcState')
  onMatchGcStateChanged(val: 'PAUSED' | 'STARTED' | 'STOPPED'): void {
    if (val === 'STARTED') {
      this.startRealtimeInterval()
      return
    }

    this.stopRealtimeInterval()
  }

  /**
   * Game Clock progress
   */
  get progress(): number {
    return this.$store.getters['match/periodProgressPercentage']
  }

  /**
   * Line Main Color for Clock progress
   */
  get clockProgressLineMainColor(): string {
    if (!this.match) {
      return 'blue'
    }

    return this.match.gcState === 'STARTED' ? 'rgb(0, 150, 255)' : 'grey'
  }

  /**
   * Line Background Color for Clock progress
   */
  get clockProgressLineBgColor(): string {
    if (!this.match) {
      return 'blue'
    }

    return this.match.gcState === 'STARTED'
      ? 'rgba(208, 234, 246, 1)' // Started color (blue-ish)
      : 'rgba(200, 200, 200, 0.3)' // Paused color (grey-ish)
  }

  /**
   * Background color for whole clock progress
   */
  get clockProgressBgColor(): string {
    if (!this.match) {
      return ''
    }

    return this.match.gcState === 'STARTED'
      ? 'rgba(255, 255, 255, 1)' // Started - transparant
      : 'rgba(255, 255, 255, 0.5)' // Paused color (grey-ish)
  }

  /**
   * Tap text
   */
  get tapText(): string {
    if (!this.match) {
      return ''
    }

    if (this.$store.getters['match/isReadyForNextPeriod']) {
      if (!this.$store.getters['match/canGotoNextPeriod']) {
        return 'Match finished'
      }

      return 'Tap to goto next period'
    }

    return `Tap to ${this.match.gcState === 'STARTED' ? 'pause' : 'start'} clock`
  }

  /**
   * Toggle start/pause clock
   */
  toggleStartPauseClock(): void {
    // console.log('Toggle clock state')

    // Guard controls-lock enabled
    if (this.$store.state.match.controlsLocked) {
      return
    }

    // Guard no match
    if (!this.match) {
      return
    }

    if (this.$store.getters['match/isReadyForNextPeriod']) {
      if (!this.$store.getters['match/canGotoNextPeriod']) {
        // window.flash('Match finished', 'error')
        return
      }
      this.$store.dispatch('match/gotoNextPeriod')
    } else if (this.match.gcState === 'STARTED') {
      this.pauseClock()
    } else {
      this.startClock()
    }
  }

  /**
   * Start clock logic
   */
  startClock(adjustInSec = 0): void {
    // console.log('Start clock')

    // Update real time timestamp to ensure
    // the presented clock upon start of clock is not 'flashing' with old value
    this.$store.commit('match/refreshRealtimeTimestamp')

    this.$store.dispatch('match/startClock', adjustInSec)
  }

  /**
   * Pause clock logic
   */
  pauseClock(adjustInSec = 0): void {
    this.$store.dispatch('match/pauseClock', adjustInSec)
  }

  /**
   * Adjust clock
   */
  adjustClock(adjustInSec: number): void {
    // console.log('Adjust clock with sec', adjustInSec)

    if (!this.match) {
      return
    }

    if (this.match.gcState === 'STARTED') {
      this.startClock(adjustInSec)
    } else {
      this.pauseClock(adjustInSec)
    }
  }

  /**
   * Goto next period logic
   */
  gotoNextPeriod(): void {
    // Guard ready for next period
    if (!this.$store.getters['isReadyForNextPeriod']) {
      return
    }

    this.$store.dispatch('match/gotoNextPeriod')
  }

  startRealtimeInterval(): void {
    this.$store.dispatch('match/startRealtimeInterval')
  }
  stopRealtimeInterval(): void {
    this.$store.dispatch('match/stopRealtimeInterval')
  }

  /**
   * Before destroy of vue view - ensure timers/intervals are free'd
   */
  beforeDestroy(): void {
    this.$store.commit('match/stopRealtimeInterval')
  }
}
